var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import { Button } from "syf-component-library/ui/atoms";
var InlineButton = styled(Button)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 0;\n  margin-top: 0px;\n  align-items: flex-start;\n  font-size: 1rem;\n  overflow: unset;\n  width: fit-content;\n"], ["\n  padding: 0;\n  margin-top: 0px;\n  align-items: flex-start;\n  font-size: 1rem;\n  overflow: unset;\n  width: fit-content;\n"])));
export default InlineButton;
var templateObject_1;
